export default __webpack_public_path__ + "static/media/vid11.ffbff71b.mp4";